<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Renouvellement d'agrément">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="11">
              <p class="subtitle-1 text-left font-weight-bold">
                Origine de la demande
              </p>
              <v-row>
                <v-col cols="12" md="2">
                  <p class="subtitle-1 text-left">
                    &Eacute;chéance de l'agrément :
                  </p></v-col
                >
                <v-col cols="12" md="6">
                  <v-radio-group
                    v-model="dossier.agrementEcheance"
                    row
                    required
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="agrementEcheance"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="agrementEcheance"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="dossier.agrementEcheance">
                <v-col cols="12" md="7">
                  <p class="subtitle-1 text-left">
                    Stagiaires formés durant la période d’agrément écoulée :
                  </p>
                  <v-data-table
                    dense
                    hide-default-footer
                    :headers="getStagiairesFormesHeader()"
                    :items="getStagiairesFormesItems()"
                    item-key="name"
                    class="elevation-1"
                  >
                    <!--ANNEE 1-->
                    <template v-slot:item.anneeA="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.anneeA"
                        large
                        persistent
                        cancel-text="Annuler"
                        save-text="Remplacer"
                      >
                        <div>{{ props.item.anneeA }}</div>
                        <template v-slot:input>
                          <div class="mt-4 title">
                            Mettre à jour le nombre de stagiaires
                          </div>
                          <v-text-field
                            v-model="props.item.anneeA"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <!--ANNEE 2-->
                    <template v-slot:item.anneeB="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.anneeB"
                        large
                        persistent
                        cancel-text="Annuler"
                        save-text="Remplacer"
                      >
                        <div>{{ props.item.anneeB }}</div>
                        <template v-slot:input>
                          <div class="mt-4 title">
                            Mettre à jour le nombre de stagiaires
                          </div>
                          <v-text-field
                            v-model="props.item.anneeB"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <!--ANNEE 3-->
                    <template v-slot:item.anneeC="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.anneeC"
                        large
                        persistent
                        cancel-text="Annuler"
                        save-text="Remplacer"
                      >
                        <div>{{ props.item.anneeC }}</div>
                        <template v-slot:input>
                          <div class="mt-4 title">
                            Mettre à jour le nombre de stagiaires
                          </div>
                          <v-text-field
                            v-model="props.item.anneeC"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <!--ANNEE 4-->
                    <template v-slot:item.anneeD="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.anneeD"
                        large
                        persistent
                        cancel-text="Annuler"
                        save-text="Remplacer"
                      >
                        <div>{{ props.item.anneeD }}</div>
                        <template v-slot:input>
                          <div class="mt-4 title">
                            Mettre à jour le nombre de stagiaires
                          </div>
                          <v-text-field
                            v-model="props.item.anneeD"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <!--ANNEE 5-->
                    <template v-slot:item.anneeE="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.anneeE"
                        large
                        persistent
                        cancel-text="Annuler"
                        save-text="Remplacer"
                      >
                        <div>{{ props.item.anneeE }}</div>
                        <template v-slot:input>
                          <div class="mt-4 title">
                            Mettre à jour le nombre de stagiaires
                          </div>
                          <v-text-field
                            v-model="props.item.anneeE"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <p class="subtitle-1 text-left">
                    Changement de lieu d’exercice :
                  </p></v-col
                >
                <v-col cols="12" md="6">
                  <v-radio-group
                    v-model="dossier.changementLieu"
                    row
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="changementLieu"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="changementLieu"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="5">
                  <p class="subtitle-1 text-left">
                    Avez-vous fait partie d’un jury d’examen au cours des 5
                    dernières années ?
                  </p></v-col
                >
                <v-col cols="12" md="6">
                  <v-radio-group
                    v-model="dossier.juryMembre"
                    row
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="juryMembre"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="juryMembre"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie3",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    stagiairesFormesHeader: [
      { text: "Stage", value: "stage", sortable: false },
      {
        text: "Année " + (new Date().getFullYear() - 4),
        value: "anneeA",
        sortable: false
      },
      {
        text: "Année " + (new Date().getFullYear() - 3),
        value: "anneeB",
        sortable: false
      },
      {
        text: "Année " + (new Date().getFullYear() - 2),
        value: "anneeC",
        sortable: false
      },
      {
        text: "Année " + (new Date().getFullYear() - 1),
        value: "anneeD",
        sortable: false
      },
      {
        text: "Année " + new Date().getFullYear(),
        value: "anneeE",
        sortable: false
      }
    ],
    stagiairesFormesItems: [
      {
        stage: "Stage d’initiation",
        anneeA: "-",
        anneeB: "-",
        anneeC: "-",
        anneeD: "-",
        anneeE: "-"
      },
      {
        stage: "Stage d’application des enseignements coordonnés",
        anneeA: "-",
        anneeB: "-",
        anneeC: "-",
        anneeD: "-",
        anneeE: "-"
      },
      {
        stage: "Stage de pratique professionnelle",
        anneeA: "-",
        anneeB: "-",
        anneeC: "-",
        anneeD: "-",
        anneeE: "-"
      }
    ],
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"]
  }),
  computed: {
    stagiairesFormesRecorded: function() {
      return JSON.parse(this.dossier.stagiairesFormes);
    }
  },
  methods: {
    getStagiairesFormesHeader() {
      if (this.stagiairesFormesRecorded != null) {
        if (this.stagiairesFormesRecorded.header) {
          return this.stagiairesFormesRecorded.header;
        }
      }
      return this.stagiairesFormesHeader;
    },
    getStagiairesFormesItems() {
      if (this.stagiairesFormesRecorded != null) {
        if (this.stagiairesFormesRecorded.items) {
          return this.stagiairesFormesRecorded.items;
        }
      }
      return this.stagiairesFormesItems;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        let stagiairesFormes = {
          header: this.stagiairesFormesHeader,
          items: this.getStagiairesFormesItems()
        };
        this.dossier.stagiairesFormes = JSON.stringify(stagiairesFormes);
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>

<style>
.v-input--radio-group--row {
  padding-top: 0 !important;
  margin-top: 0 !important;
}
</style>
